import { createContext } from "react";

export interface CXSignupDialogContextType {
  open: (options?: { forced?: boolean }) => void;
  close: () => void;
  isOpen: boolean;
  isForced: boolean;
}

export const CXSignupDialogContext =
  createContext<CXSignupDialogContextType | null>(null);
